import $ from 'jquery';
import React from 'react';
import { NavbarToggler } from 'reactstrap';

const Toggler: React.SFC = () => {
    return (
        <NavbarToggler
            onClick={() => {
                $('.side-menu').toggleClass('slide-in');
                $('.navbar-nav').toggleClass('slide-in');
                $('.side-body').toggleClass('body-slide-in');
            }}
        />
    );
};

export default Toggler;